<div class="fulfillmentLanding xs-mt-0 xs-mb-20">
  <div class="status-bar">
    <div><span class="font16 pr-2">Status Notice:</span><span>{{bannerMessage}}</span></div>
  </div>
</div>

<div class="fulfillmentLanding seed-return-wrapper">
  <div class="cppReturnsLandingPage">
    <div class="row">
      <div class="col-md-10 col-lg-10 margin-l0 TopSec">
        <h3>
          COI Fulfillment
        </h3>
        <p class="smalltext landing-small-text">
          Filter COI Fulfillment requests by choosing the type of filter you`d like to use and searching for a value. You may opt to view your submitted COI Fulfillment Requests on the tab below, or see your saved drafts by selecting COI Request drafts tab.
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-10 col-md-8 pr-0">
        <app-filter [(optionsData)]="filterOptionsData" [isSearchButtonOutside]="true" (searchClick)="filterSearchClick($event)" (clearAllClick)="filterClearAllClick($event)"></app-filter>
      </div>
      <div class="col-lg-2 col-md-4 margin-t12 text-left">
        <button mat-raised-button class="btns xs-button xs-full-width export-button" [disabled]="(this.selectedTabIndex === 0 && this.coiDataList && this.coiDataList.length <= 0) || (this.selectedTabIndex === 1 && this.draftCoiDataList && this.draftCoiDataList.length <= 0)" (click)="export()">Export</button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 legend-outer">

        <mat-tab-group disableRipple [animationDuration]="'400ms'" class="matTabs prepayLandingTab" (selectedTabChange)="tabChanged($event)">

          <mat-tab>
            <ng-template mat-tab-label>
              <i class="icon-ico-dealer_icon padding-t10 xs-mr-5" aria-hidden="true"></i>
              <div class="tab-head">
                <h4>
                  Active COI Requests
                </h4>
              </div>
            </ng-template>
            <div class="fulfill-top-sec">
              <div class="row listing-action-items">
                <div class="col-sm-4">
                </div>
                <div class="col-xl-8 col-lg-8 col-md-8 text-right">
                  <div class="display-ib wAuto">
                    <mat-paginator #coiPaginator [pageSize]="masterConstants.PAGE_SIZE" [pageSizeOptions]="masterConstants.PAGE_SIZE_OPTIONS"></mat-paginator>
                  </div>
                  <button *ngIf="!readOnlyAccess" mat-raised-button class="btns margin-l5 index-z200" color="primary" (click)="createNewRequest()">Create New Request</button>
                </div>
              </div>
            </div>

            <div class="tableContainer activeReturnRequest">
              <table mat-table #coiTable [dataSource]="coiDataSource" matSort #coiSort matSortDirection="desc" class="matTables coiActiveTable">
                <ng-container matColumnDef="requestId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">Request Id</th>
                  <td mat-cell *matCellDef="let element" class="text-left">
                    <div class="order-info handCursor" (click)="viewOrderDetail(element,false,'placed')">
                      <u>
                        <p class="font14">
                          {{element.coiorderNumber}}
                        </p>
                      </u>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="custPONumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">Customer PO</th>
                  <td mat-cell *matCellDef="let element" class="ml-0 text-left pl-2">
                    <div class="order-info cursor-default-pointer">
                      <p class="grower-name">
                        {{element.custPONumber}}
                      </p>
                      <p></p>
                    </div>
                  </td>
                </ng-container>
                <!--<ng-container matColumnDef="accountName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">Account Name</th>
                  <td mat-cell *matCellDef="let element" class="ml-0">
                    <div class="order-info cursor-default-pointer">
                      <p class="grower-name">
                        {{element.accountName}}
                      </p>
                      <p class="accAddress">{{element.accountAddress1 || element.accountAddress2}}, {{element.accountCity}}, {{element.accountState}} {{element.accountZipCode}}</p>
                    </div>
                  </td>
                </ng-container>-->
                <ng-container matColumnDef="accountName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="accName text-center">Account Name </th>
                  <td mat-cell *matCellDef="let element">
                    <div class="order-info defaultCursor">
                      <p class="grower-name">
                        {{element.accountName}}
                      </p>
                      <p class="font14 accAddress">{{element.accountAddress1 || element.accountAddress2}}, {{element.accountCity}}, {{element.accountState}} {{element.accountZipCode}}</p>
                    </div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>  </td>
                </ng-container>
                <ng-container matColumnDef="accountNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo  text-center">Account #</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{element.accountNumber}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="requestDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo  text-center">Request Date</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{element.requestDate | date: masterConstants.DATE_MMDDYYYY}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">Status</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{element.status}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="viewOrder">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo  text-center"></th>
                  <td mat-cell *matCellDef="let element" class="text-left">
                    <div>
                      <button mat-button [matMenuTriggerFor]="beforeMenu1" class="context-menu">
                        <i class="fas fa-ellipsis-v blue-color"></i>
                      </button>
                      <mat-menu #beforeMenu1="matMenu" xPosition="before" class="context-meun-dropdown">
                        <button mat-menu-item (click)="viewOrderToInvoice(element)">View Order</button>
                        <button mat-menu-item (click)="emailOrderDetail(element)">Email Request</button>
                        <button mat-menu-item (click)="generatedPdf(element)">Download PDF</button>
                      </mat-menu>
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="coiColumns;sticky:true;"></tr>
                <tr mat-row *matRowDef="let row; columns: coiColumns;"></tr>
              </table>
              <div *ngIf="coiDataList == undefined || coiDataList.length == 0" class="noDataMsg">
                <p class="padding-b47">No Record Found.</p>
              </div>
            </div>
          </mat-tab>

          <mat-tab>
            <div class="col-md-2">
              <ng-template mat-tab-label>
                <i class="icon-ico-grower_icon padding-t10 xs-mr-5" aria-hidden="true"></i>
                <div class="tab-head">
                  <h4>
                    Draft COI Requests
                  </h4>
                </div>
              </ng-template>
            </div>
            <div class="fulfill-top-sec">
              <div class="row listing-action-items">
                <div class="col-xl-4 col-lg-4 col-md-3 smallPadRgt0">
                </div>
                <div class="col-xl-8 col-lg-8 col-md-8 text-right">
                  <div class="display-ib wAuto">
                    <mat-paginator #draftCoiPaginator [pageSize]="masterConstants.PAGE_SIZE" [pageSizeOptions]="masterConstants.PAGE_SIZE_OPTIONS"></mat-paginator>
                  </div>
                </div>
              </div>
            </div>
            <div class="tableContainer draftReturnRequest">
              <table mat-table #draftCoiTable [dataSource]="draftCoiDataSource" matSort #draftCoiSort matSortDirection="desc" class="matTables coiDraftTable">
                <ng-container matColumnDef="requestId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">Request Id</th>
                  <td mat-cell *matCellDef="let element" class="text-left">
                    <div class="order-info handCursor" (click)="navigateCoiRequestDetail(element,'OrderCreated')">
                      <u>
                        <p class="font14">
                          {{element.coiorderNumber}}
                        </p>
                      </u>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="custPONumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center pl-2">Customer PO</th>
                  <td mat-cell *matCellDef="let element" class="ml-0">
                    <div class="order-info cursor-default-pointer">
                      <p class="grower-name">
                        {{element.custPONumber}}
                      </p>
                      <p></p>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="accountName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center pl-2">Account Name</th>
                  <td mat-cell *matCellDef="let element" class="ml-0">
                    <div class="order-info cursor-default-pointer">
                      <p class="grower-name">
                        {{element.accountName}}
                      </p>
                      <p class="font14 accAddress">{{element.accountAddress1 || element.accountAddress2}}, {{element.accountCity}}, {{element.accountState}} {{element.accountZipCode}}</p>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="accountNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">Account #</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{element.accountNumber}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="draftDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo  text-center">Draft Date</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{element.draftDate | date: masterConstants.DATE_MMDDYYYY}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">Status</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{element.status}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="deleteRequest">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo  text-center">Delete Request</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <i title="delete" class="icon-ico-trash handCursor" (click)="deletecoidraftrequest(element)"></i>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="draftCoiColumns;"></tr>
                <tr mat-row *matRowDef="let row; columns: draftCoiColumns;"></tr>
              </table>
              <div *ngIf="draftCoiDataList == undefined || draftCoiDataList.length == 0" class="noDataMsg">
                <p class="padding-b47">No Record Found.</p>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>
